<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          :title="$t('Assessments.tableHeading')"
          :text="$t('Assessments.tableDescription')"
        >
          <v-data-table
            v-if="assessmentsWithClients"
            :headers="headers"
            :items="assessmentsWithClients"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      :id="`automation-id-Assessments-btn-new`"
                      elevation-4
                      light
                      color="green darken-2"
                      @click="$router.push({ path: '/assessment' })"
                      class="white--text"
                    >
                      <!-- addNew method toggles the dialog (this is included in the mixinDialogEdit mixin) -->
                      <!-- elements used for automated end to end testing needs an id: automation-id-Clinics-element-description -->
                      <v-icon>
                        mdi-plus
                      </v-icon>
                      {{ $t('Assessments.newButton')}}
                    </v-btn>
                    <v-btn
                      :id="`automation-id-Clinics-btn-refresh`"
                      @click="loadAssessmentsWithClients()"
                      text
                      icon
                      color="green"
                      class="float-right">
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:item.created="{ item }">
              <span v-text="new Date(item.created).toLocaleDateString(undefined, { dateStyle: 'long' })" />
            </template>
            <template v-slot:item.isCompleted="{ item }">
              <aurora-bool-field :boolValue="item.isCompleted">
                <template v-slot:true>
                  Yes
                </template>
                <template v-slot:false>
                  No
                </template>
              </aurora-bool-field>
            </template>
            <template v-slot:item.links="{ item }">
              <v-icon small @click="$router.push({ name: 'Assessment Items', query: { assessmentId: item.id }})">mdi-eye</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
              <aurora-data-table-actions
                :items="assessmentsWithClients"
                :item="item"
                name="Metrics"
                @edit="editAssessment"
                @delete="deleteItem"
              />
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data: () => ({
    headers: [
      {
        sortable: true,
        text: 'Name',
        value: 'name',
      },
      {
        sortable: true,
        text: 'Client',
        value: 'client.name',
      },
      {
        sortable: true,
        text: 'Frequency',
        value: 'frequency',
      },
      {
        sortable: true,
        text: 'Started',
        value: 'created',
      },
      {
        sortable: true,
        text: 'Total Score',
        value: 'totalScore',
      },
      {
        sortable: false,
        text: 'Is Completed',
        value: 'isCompleted',
      },
      {
        sortable: false,
        text: '',
        value: 'links',
      },
      {
        sortable: false,
        text: '',
        value: 'action',
      },
    ],
  }),
  computed: {
    ...mapState('assessments', ['assessmentsWithClients']),
  },
  mounted() {
    this.loadAssessmentsWithClients(this.assessmentId);
  },
  methods: {
    ...mapActions('assessments', ['loadAssessmentsWithClients']),
    editAssessment(item) {
      this.$router.push({ name: 'Edit Assessment', params: { id: item.id } });
    },
    exportAssessment(item) {
      this.$auroraHub.$emit('app.loading');
      this.$http({
        url: `${this.$auroraSettings.apiUrl}/odataAurora/assessments/export?id=${item.id}`,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Assessment-${item.name}.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.$auroraHub.$emit('app.loaded');
      });
    },
    deleteItem(item) {
      this.$root.$confirm('Are you sure you want to delete this?').then((confirm) => {
        if (confirm) {
          this.$store.dispatch('odata/delete.assessment', item.id);
        }
      });
    },
  },
};
</script>
